import styled from 'styled-components'
import { Row, Col } from 'react-styled-flexboxgrid'
import variables from '../../styles/variables'
import { TextWrapper } from '../../styles/base'
import { headerStyles } from '../../styles/global'
import plusPattern from '../../../assets/plus-pattern.svg'
import { Heading } from '..'

export const Container = styled.div`
  padding-top: 80px;
`
export const ColorsSection = styled(TextWrapper)`
  ul {
    display: flex;
    flex-direction: row;

    li:not(:first-child) {
      margin-left: 20px;
    }
  }
`

export const MainPointImageContainer = styled.div`
  position: relative;
`

export const MainPointGraphicBackground = styled.img`
  width: 280px;
  height: 230px;
  position: relative;
  z-index: 1;
  object-fit: cover;
  
  @media ${variables.media.sm} {
    width: 400px;
    height: 300px;
    left: -100px;
  }
  
  @media ${variables.media.md} {
    width: 450px;
    height: 400px;
    left: -120px;
  }
`

export const MainPointPolaroidImage = styled.img`
  max-width: 100%;
  width: 250px;
  position: absolute;
  left: 70px;
  top: 40px;
  box-shadow: 1px 4px 10px 5px rgba(0, 0, 0, 0.2);
  z-index: 2;

  @media ${variables.media.sm} {
    width: 330px;
    left: 35px;
    top: 55px;
  }
  
  @media ${variables.media.md} {
    width: 430px;
    top: 70px;
    left: 0;
  }
`

export const UseCasesCarouselHeader = styled(Heading)`
  ${headerStyles.headerSmall} 
  font-weight: normal;
  text-align: center;
  color: ${variables.colors.silverTree.darker};
  @media ${variables.media.sm} {
    margin-bottom: 60px;
  }
`

export const SelectedUseCaseSection = styled(TextWrapper)`
  padding: 20px 0 0 0;
  @media ${variables.media.sm} {
    padding: 60px 100px;
  }
  @media ${variables.media.md} {
    padding: 60px 50px 60px 150px;
  }

`

export const SelectedUseCaseHeader = styled(Heading)`
  ${headerStyles.headerXSmall}
  color: ${variables.colors.oracle.dark};
  margin-left: 20px;

  @media ${variables.media.sm} {
    margin-left: 0;
  }
`

export const MainPointsContainer = styled.div`
  background-image: url(${plusPattern});
  padding-top: 30px;
  padding-bottom: 0;
`

export const MainPointsSection = styled(TextWrapper)`

`

export const MainPointColCenterer = styled.div`
  display: flex;
  justify-content: center;
`

export const MainPointAnimation = styled.div`
`

export const MainPointItemRow = styled(Row)`
  margin-bottom: 60px;

  @media ${variables.media.sm} {
    margin-bottom: 100px;
  }

  /*
  These animations fill up different space of the canvas, we need to manually
  make one smaller to make the animations visually look same size
  */

  &:nth-of-type(3), &:nth-of-type(1) {
    ${MainPointAnimation} {
      max-width: 150px;
      max-height: 150px;
      margin-top: 30px;
    }

    @media ${variables.media.sm} {
      ${MainPointAnimation} {
        max-width: 300px;
        max-height: 300px;
      }
    }
  }
`

export const MainPointItemCol = styled(Col)`
`

export const MainPointsHeader = styled(Heading)`
  ${headerStyles.headerXSmall}
  color: ${variables.colors.jade.medium};
  margin-bottom: 20px;

  @media ${variables.media.sm} {
    margin-bottom: 50px;
  }
`

export const MainPointsButton = styled.div`
  width: 100%;
  display:flex;
  justify-content: center;
  padding-bottom: 40px;
  @media ${variables.media.sm} {
    justify-content: flex-start;
    padding: 0;
  }
`

export const MainPointsSectionHeader = styled(Heading)`
  margin-top: 45px;
  font-weight: 400;
`

export const MainPointsTagline = styled.p`
  font-size: 1.2rem;
  margin-top: 30px;
  margin-bottom: 30px;

  @media ${variables.media.sm} {
    margin-bottom: 50px;
  }
`
export const Centerer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const CallToActionContainer = styled(Centerer)`
  flex-direction: column;
`

export const SideSquareContainer = styled.div`
  position: relative;
  height: 0;
`
export const SquareContainer = styled(TextWrapper)`
  padding: 0 !important;

  @media ${variables.media.sm} {
    max-width: ${variables.maxContentWidth + 300}px;
  }
`
